import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import FormHeader from './FormHeader';
import FormFooter from './FormFooter';
import ArrowBack from '../../components/ArrowBack/ArrowBack';
import { isBrowser, isMobile } from 'react-device-detect';
import { withRouter } from 'react-router-dom';

function SignUpIndex (props) {
  const breakpoint = useMediaQuery('(min-width:768px)');
  return (
    <div className="flexContainer--center">
      <div style={{ width: 496 }}>
        <FormHeader />
        {isMobile && props.history.location.pathname != "/registro-abogados" &&  <ArrowBack />}
        {isBrowser && props.history.location.pathname != "/registro-abogados" &&  (
          <ArrowBack
            left={breakpoint ? '54%' : '4%'}
            top="18%"
            text="regresar"
          />
        )}
        {props.children}
        <FormFooter />
      </div>
    </div>
  );
}

export default withRouter (SignUpIndex);